module.exports = __webpack_public_path__ + "img/third-1.07a527ad.webp";